import app from './Vue/app';
import ImageCard from '@components/ImageCard.vue';
import PopCard from '@components/PopCard.vue';
import SocialCarousel from '@components/home/SocialCarousel.vue';
import ProfileAnimation from '@components/ProfileAnimation.vue';

app.component('ImageCard', ImageCard);
app.component('PopCard', PopCard);
app.component('SocialCarousel', SocialCarousel);
app.component('ProfileAnimation', ProfileAnimation);
